import { RootState } from 'store';

const MissingQualificationsState = (state: RootState) => state.weeklyPlanner.missingQualifications;

export const selectAll = (state: RootState) => MissingQualificationsState(state).rows;
export const selectLoading = (state: RootState) => MissingQualificationsState(state).loading;
export const selectHasLoaded = (state: RootState) => MissingQualificationsState(state).hasLoaded;
export const selectParams = (state: RootState) => MissingQualificationsState(state).params;
export const selectCount = (state: RootState) => MissingQualificationsState(state).count;
